import React, { useEffect, useState } from 'react'

import { Skeleton, Tabs, Row, Col } from 'antd'
import apolloClient from 'clients/apollo'

import { FETCH_SERVICES } from 'shared/gql'
import { Service } from 'shared/types'
import { ServicePane } from './ServicePane'
import { StripeBilling } from 'saas/stripe'
import AppState from 'shared/app_state'
import { Card, CardContent } from '@mui/material';

const { TabPane } = Tabs

const StripeBillingView: React.FC<{ accountId: string }> = ({ accountId }) => {
  const [activeServiceTab, setActiveServiceTab] = useState<string>(null)
  const [services, setServices] = useState<Service[]>(null)

  const onChangeActiveServiceTab = (newTab: string): void => {
    setActiveServiceTab(newTab)
  }

  const tabFromService = (service: Service): { key: string; label: string } => ({
    key: service.name.toLowerCase(),
    label: service.name,
  })

  const fetchServices = async (): Promise<Service[]> => {
    try {
      const {
        data: { allServices: services },
      } = await apolloClient.query({
        query: FETCH_SERVICES,
        variables: { filter: {}, sort: { field: 'name', order: 'ASC' } },
        // fetchPolicy: 'no-cache',
      })

      setServices(services)
      return services
    } catch (e) {
      console.error(e)
      // setError(JSON.stringify(e))
      return null
    }
  }

  const initTabs = (services: Service[]): void => {
    setActiveServiceTab(tabFromService(services[0]).key)
  }

  const init = async (): Promise<void> => {
    try {
      const services = await fetchServices()
      if (services.length > 0) initTabs(services)
    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    // init()
  }, [])

  // if (!activeServiceTab) return <Skeleton active />

  const renderUpgradeBillingButton = () => {
    const billingEmail = AppState.getCurrentAccount().billingContactEmail
    const currentUserEmail = AppState.getCurrentUser().email

    if (billingEmail == currentUserEmail) return (
      <div>
        <p>
          <a href={`${process.env.STRIPE_CUSTOMER_PORTAL_LINK}?prefilled_email=${currentUserEmail}`} target="_blank">Upgrade Your Plan</a>
        </p>
      </div>
    )

    return (
      <div>
        <p>The billing contact for your account is <a href={`mailto:${billingEmail}`}>{billingEmail}</a>.</p>
        <p>Contact them to make changes to your plan.</p>
      </div>
    )
  }

  const renderPriceTable = () => {
    return (
      <stripe-pricing-table pricing-table-id="prctbl_1LxedOCyKWM7N4GwvSxpZVAB"
        publishable-key="pk_live_51IlJWlCyKWM7N4Gweuy3YovxftCrM0E1NDDK91OxyXz358Icdzwym99WslIhXEANzs2SqP8c6xDDxJwBJB5FUQjC00DFxIqqOx">
      </stripe-pricing-table>
    )
  }

  return (
    <Card>
      <CardContent>

        {/* <h3>TODO:</h3>
      <ol>
        <li>Singular query endpoint to fetch active subscriptions</li>
        <li>Admin services view</li>
        <li>Map features / Plans</li>
        <li>Dynamically display current subscription</li>
        <li>
          Determine what needs to happen in StripeJob::SubscriptionUpdated (i.e. update subscription status, update
          features)
        </li>
        <li>Improve tabbed services layout</li>
      </ol> */}
        {/* <Tabs
        tabPosition="left"
        activeKey={activeServiceTab}
        onChange={onChangeActiveServiceTab}
        style={{
          minWidth: '100%',
        }}
      >
        {services.map((service) => {
          const tab = tabFromService(service)

          return (
            <TabPane tab={tab.label} key={tab.key}>
              <StripeBilling.ServiceSubscriptionsManager accountId={accountId} apolloClient={apolloClient} service={service}>
                <ServicePane accountId={accountId} service={service} />
              </StripeBilling.ServiceSubscriptionsManager>
            </TabPane>
          )
        })}
      </Tabs> */}
        {
          AppState.getCurrentAccount().billingContactEmail ? renderUpgradeBillingButton() : renderPriceTable()
        }
      </CardContent>
    </Card>
  )
}

export default StripeBillingView
